import * as IoC from 'typescript-ioc';
import { JobConfiguration } from '../../job-configuration';
import { JobType } from '../../../../api/jobs.dao';
import { IAttendeesDAO } from '../../../../api/attendees.dao';

export class GenerateAccessCodesJob extends JobConfiguration {
    public readonly type = JobType.GenerateAccessCodes;
    public readonly name = 'Generate Access Codes';
    public readonly description = 'Access Codes Generation';

    public async execute(execParams) {
        return IoC.Container.get(IAttendeesDAO).generateAccessCodes(execParams);
    }
}

export default {
    [JobType.GenerateAccessCodes]: GenerateAccessCodesJob
};
